export const DEPOSIT_POLICY =
  'A 50% deposit is required to secure all bookings for detailing packages, paint correction, ceramic coating, and fleet services. Quick hand washes and maintenance washes are paid in full at the time of service — no deposit required. Contact us for a personalized quote.';
